__turbopack_context__.v({
  "className": "spectral_c00f77a9-module__qgnD5W__className",
  "variable": "spectral_c00f77a9-module__qgnD5W__variable",
});
